<div class="textoUltimoVideo">
    ÚLTIMO VIDEO
</div>

<div class="row padded">
    
    <div class="col-12 col-md-6 noticiaMain invisibleMenor">
        <div class="container">
            <iframe class="responsive-iframe" src="https://www.youtube.com/embed/lFlkYz7szZw"></iframe>
        </div>
    </div>
    <div class="col-6 col-md-6 invisibleMenor">
        <div class="img2live">
            <div class="contenttxtport">
                <div class="txtcentradoport">
                    <p class="textStreaming">STREAMING</p>
                </div>
            </div>
        </div>
    </div>
    
    

    <div class="col-4 invisibleMenor">
        <div class="container">
            <iframe class="responsive-iframe" src="https://www.youtube.com/embed/lFlkYz7szZw"></iframe>
        </div>
    </div>
    <div class="col-4 invisibleMenor">
        <div class="container">
            <iframe class="responsive-iframe" src="https://www.youtube.com/embed/lFlkYz7szZw"></iframe>
        </div>
    </div>
    <div class="col-4 invisibleMenor">
        <div class="container">
            <iframe class="responsive-iframe" src="https://www.youtube.com/embed/lFlkYz7szZw"></iframe>
        </div>
    </div>

    <!--Pantallas pequeñas (menores a 768)-->
    <div class="col-1 invisibleInvertido iconos">
        <mat-icon aria-hidden="false" class="back" aria-label="Example home icon" style="font-size: 50px; text-align: center;">
            keyboard_arrow_left</mat-icon>
    </div>
    <div class="col-10 invisibleInvertido">
        <div class="container">
            <iframe class="responsive-iframe" src="https://www.youtube.com/embed/lFlkYz7szZw"></iframe>
        </div>
    </div>
    <div class="col-1 invisibleInvertido iconos" style=" margin-left: -20px; vertical-align: middle;">
        <mat-icon aria-hidden="false" class="next" aria-label="Example home icon" style="font-size: 50px; text-align: left;">
            keyboard_arrow_right</mat-icon>
    </div>
    <div class="verMas">
        <button mat-raised-button color="warn" routerLink="/envivo"  >
            VER MÁS
        </button>
    </div>
    <!--Pantallas pequeñas (menores a 768) fin-->
</div>